// import React from 'react';
// // Original imports - kept for easy revert later
// // import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// // import Header from './components/Header';
// // import Footer from './components/Footer';
// // import Home from './pages/Home';
// // import AboutUs from './pages/AboutUs';
// // import Curriculum from './pages/Curriculum';
// // import HealthyEating from './pages/HealthyEating';
// // import AdmissionFees from './pages/AdmissionFees';
// // import ContactUs from './pages/ContactUs';
// // import ContactSection from './components/ContactSection';
// // import Partners from './components/Partners';
// // import LanguageTranslator from './components/LanguageTranslator';

// // Coming Soon Page Import
// import ComingSoon from './components/ComingSoon';
// import './App.css';

// /* 
//   ORIGINAL MAIN LAYOUT - Uncomment this and comment out the Coming Soon section below to restore the full website

// const MainLayout = () => {
//   const location = useLocation();
//   const isContactPage = location.pathname === '/contact';

//   return (
//     <div className="d-flex flex-column min-vh-100">
//       <Header />
//       <main className="flex-grow-1">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/about" element={<AboutUs />} />
//           <Route path="/curriculum" element={<Curriculum />} />
//           <Route path="/healthy-eating" element={<HealthyEating />} />
//           <Route path="/admission" element={<AdmissionFees />} />
//           <Route path="/contact" element={<ContactUs />} />
//         </Routes>
//       </main>
//       {!isContactPage && <ContactSection />}
//       {!isContactPage && <Partners />}
//       <Footer />
//       <LanguageTranslator />
//     </div>
//   );
// };
// */

// // COMING SOON MODE - Comment this out and uncomment above to restore full website
// function App() {
//   return <ComingSoon />;
// }

// export default App;


































import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Curriculum from './pages/Curriculum';
import HealthyEating from './pages/HealthyEating';
import AdmissionFees from './pages/AdmissionFees';
import ContactUs from './pages/ContactUs';
import ContactSection from './components/ContactSection';
import Partners from './components/Partners';
import LanguageTranslator from './components/LanguageTranslator';
import './App.css';

const MainLayout = () => {
  const location = useLocation();
  const isContactPage = location.pathname === '/contact';

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/curriculum" element={<Curriculum />} />
          <Route path="/healthy-eating" element={<HealthyEating />} />
          <Route path="/admission" element={<AdmissionFees />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </main>
      {!isContactPage && <ContactSection />}
      {!isContactPage && <Partners />}
      <Footer />
      <LanguageTranslator />
    </div>
  );
};

function App() {
  return (
    <Router>
      <MainLayout />
    </Router>
  );
}

export default App;
